import { render, staticRenderFns } from "./FactoryDoor.vue?vue&type=template&id=ffbdfbea"
import script from "./FactoryDoor.vue?vue&type=script&lang=js"
export * from "./FactoryDoor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports